
<div
  v-if="items"
  tabindex="0"
  class="ws-radio-list"
  :class="{
    'invisible-wrap': invisibleWrap,
    'no-spacing-y': noSpacingY,
    'no-spacing-x': noSpacingX,
    small,
  }"
>
  <template
    v-for="(item, index) in showSelectedOnly
      ? [items[selectedIndex || 0]]
      : items"
  >
    <div
      v-if="
        !(
          get(item, 'disable') &&
          $scopedSlots.disabled &&
          $scopedSlots.disabled({ item })
        )
      "
      :key="get(item, uidProp, JSON.stringify(item)) + '_item_' + index"
      class="ws-radio-item item-spacing"
      :class="{
        disabled: get(item, 'disable'),
        selected: selectedIndex === index || showSelectedOnly,
        'selected-bolded': selectedBolded,
      }"
    >
      <label class="flex full-width cursor-pointer">
        <ws-radio
          v-if="!invisibleWrap"
          v-model="selectedIndex"
          :val="index"
          class="q-mt-sm ws-hover-fly-in-trigger"
          :class="{ selected: selectedIndex === index || showSelectedOnly }"
          :color="isTheme(Theme.ADMIN) ? 'blue' : 'green'"
          :disable="get(item, 'disable')"
          @input="$emit('ws-radio-selected')"
        ></ws-radio>
        <span class="flex-1" :class="{'q-ml-md': !invisibleWrap}">
          <slot
            :item="item"
            :index="index"
            :is-selected="selectedIndex === index || showSelectedOnly"
          ></slot>
        </span>
      </label>
      <div
        v-if="$scopedSlots.info"
        class="info"
      >
        <slot
          name="info"
          :item="item"
          :index="index"
          :is-selected="selectedIndex === index || showSelectedOnly"
        ></slot>
      </div>
      <transition name="slide-fade-vertical">
        <div
          v-if="show && index === selectedIndex"
          class="item-content"
        >
          <slot
            name="content"
            class="q-mx-lg"
            :item="item"
            :index="index"
          ></slot>
        </div>
      </transition>
    </div>
    <div
      v-else
      :key="get(item, uidProp, JSON.stringify(item)) + '_disabled_' + index"
      class="item-spacing slot-disabled"
    >
      <slot
        name="disabled"
        :item="item"
        :index="index"
      ></slot>
    </div>
  </template>

  <slot name="extra"></slot>
</div>
